import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getUserTypes } from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import Toggle from 'react-toggle'
import axios from 'axios'
import CustomFooter from '../../../common/TableBottom'
import Moment from 'react-moment'
import HasPermission from '../../../common/Permissions/HasPermission'
import CheckPermission from '../../../common/Permissions/CheckPermission'
import Button from '../../../common/CustomComponents/Button'
import Select from 'react-select'

class AllUserList extends React.Component {
  state = {
    userList: [],
    country_list: [],
    user_type: 'user',
    isLoading: false,

    keyword: '',
    pageNumber: 0,
    limit: 10,
    disabled: false,

    country: '',
    countryData: null,
  }

  debounceTimeout = null

  componentDidMount() {
    if (this.props.match.path == '/all-owner-captains/:owner_id/:owner_name') {
      this.setState(
        {
          user_type: 'captain',
        },
        () => {
          this.loadUserList()
        }
      )
    }
    this.getCountries()
  }

  loadUserList = async () => {
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant.getAPI() + `/admin/list-users/${this.state.user_type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          owner_id: this.props?.match?.params?.owner_id,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          keyword: this.state.keyword,
          country: this.state.countryData?.value,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            userList: res.data.data,
            ...res.data?.pagination,
            disabled: res.data?.pagination?.page == res.data?.pagination?.totalPages - 1 ? true : false,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isSearching: false,
        })
      })
  }

  handleStatusChange = async (id, isActive, type) => {
    var data = {
      userId: id,
      [type || 'is_active']: isActive,
    }

    await axios
      .post(Constant.getAPI() + '/user/update-user', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.loadUserList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = async (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
      userList: [],
    })

    // Auto-search with debounce for keyword field
    if (fieldName === 'keyword') {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

      this.debounceTimeout = setTimeout(() => {
        this.setState(
          {
            pageNumber: 0,
          },
          () => {
            this.loadUserList()
          }
        )
      }, 500)
    }
  }

  getListTitle = () => {
    return this.props.match.path == '/all-owner-captains/:owner_id/:owner_name'
      ? `Owner name - ${this.props.match.params.owner_name}`
      : 'Users List'
  }

  recoverUserAgain = async (user_id) => {
    await axios
      .post(
        Constant.getAPI() + '/user/recover-deleted-user',
        { user_id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.loadUserList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  searchData = () => {
    this.setState(
      {
        isSearching: true,
        pageNumber: 0,
        userList: [],
      },
      () => {
        this.loadUserList()
      }
    )
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true&all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data.map((itm) => ({
              label: `${itm.country_name_en}/${itm.country_name_ar}`,
              value: itm.country_short_name,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCountryChange = (event) => {
    this.setState({ countryData: event })
  }

  handleClear = () => {
    this.setState({ countryData: null })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          sort: true,
          display: false,
        },
      },
      {
        name: 'user_profile_thumb',
        label: 'Image',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return (
              <img
                alt=""
                src={value ? Constant.getImage() + value : './assets/images/no_image.png'}
                className="img-fluid img-40"
                onError={(event) => {
                  event.currentTarget.src = './assets/images/no_image.png'
                }}
              />
            )
          },
        },
      },
      {
        name: 'user_type',
        label: 'Role type',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return getUserTypes().find((itm) => itm?.value == value)?.label || value
          },
        },
      },
      {
        name: 'first_name',
        label: 'First Name',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'last_name',
        label: 'Last Name',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'ownerName',
        label: 'Owner Name',
        options: {
          filter: false,
          sort: false,
          display: this.state.user_type == 'captain',
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'email',
        label: 'Email',
        options: {
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>
                {value ? (
                  <>
                    {value}
                    {tableMeta.rowData[16] == 1 && (
                      <i
                        className="f-18 icofont icofont-tick-boxed m-l-10"
                        style={{ color: 'green' }}
                      ></i>
                    )}
                  </>
                ) : (
                  '--'
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'country_code',
        label: 'Country Code',
        options: {
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'phone',
        label: 'Phone Number',
        options: {
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>
                {value ? (
                  <>
                    {value}
                    {tableMeta.rowData[15] == 1 && (
                      <i
                        className="f-18 icofont icofont-tick-boxed m-l-10"
                        style={{ color: 'green' }}
                      ></i>
                    )}
                  </>
                ) : (
                  '--'
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'wallet_data',
        label: 'Wallet Balance',
        options: {
          sort: true,
          display: this.state.user_type == 'user',
          customBodyRender: (value) => {
            return (
              this.state.user_type == 'user' && (
                <>
                  {value && value.wallet_total > 0 && (
                    <>
                      <span>Waves - {value.wallet_total ? value.wallet_total : '0'}</span>
                      <br />
                    </>
                  )}
                  {value && value.expirable_wallet_total > 0 && (
                    <>
                      <span>Expirable - {value.expirable_wallet_total ? value.expirable_wallet_total : '0'}</span>
                    </>
                  )}
                  {!value?.wallet_total && !value?.expirable_wallet_total && '--'}
                </>
              )
            )
          },
        },
      },
      {
        name: 'user_otp',
        label: 'Last OTP',
        options: {
          sort: true,
          display: this.state.user_type == 'user' && HasPermission('check-user-otp'),
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'user_nationality_name',
        label: 'User Nationality',
        options: {
          sort: true,
          display: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'id',
        label: 'Captain List',
        options: {
          sort: false,
          display: this.state.user_type == 'admin',
          customBodyRender: (id, tableMeta) => {
            return (
              <div>
                <Link
                  to={`/all-owner-captains/${id}/${tableMeta.rowData[3]}`}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Captain List"
                >
                  <i className="f-20 icofont icofont-eye"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'disable_promo_email',
        label: 'Disable Promo Emails',
        options: {
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={value == true ? true : false}
                name="disable_promo_email"
                onChange={() => this.handleStatusChange(tableMeta.rowData[0], !value, 'disable_promo_email')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              tableMeta.rowData[1] != 'super-admin' && (
                <Toggle
                  id={tableMeta.rowData[0]}
                  checked={is_active === true ? true : false}
                  name="isActive"
                  onChange={() => this.handleStatusChange(tableMeta.rowData[0], !is_active)}
                />
              )
            )
          },
        },
      },
      {
        name: 'deletedAt',
        label: 'Deleted At',
        options: {
          customBodyRender: (data, tableMeta) => {
            return data ? (
              <div>
                <div>
                  <Moment format="YYYY-MM-DD">{data}</Moment>
                </div>
                <div>
                  <Button
                    variant={'only-text'}
                    onClick={() => {
                      this.recoverUserAgain(tableMeta.rowData[0])
                    }}
                  >
                    Recover
                  </Button>
                </div>
              </div>
            ) : (
              '--'
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={'/all-users/edit/' + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit Customer Details"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
              </div>
            )
          },
        },
      },
      {
        name: 'is_phone_verified',
        label: 'Phone verified',
        options: {
          sort: true,
          display: false,
        },
      },
      {
        name: 'is_email_verified',
        label: 'Email verified',
        options: {
          sort: true,
          display: false,
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      filter: false,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? 'Loading data..!' : 'Sorry, No user Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            userList: [],
          },
          () => {
            this.loadUserList()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            userList: [],
          },
          () => {
            this.loadUserList()
          }
        )
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-4">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>User Master</h4>
                    </div>
                  </div>
                </div>
                <CheckPermission permission={'create-account'}>
                  <div className="col-8 text-right">
                    <Button
                      variant="contained"
                      to="/all-users/add"
                      onClick={this.handleUpdate}
                    >
                      Create new
                    </Button>
                  </div>
                </CheckPermission>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Search User</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="keyword"
                              className="form-control"
                              value={this.state.keyword}
                              name="keyword"
                              placeholder="Search User"
                              onKeyPress={this.handleKeyPress}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      {this.props.match.path != '/all-owner-captains/:owner_id/:owner_name' && (
                        <div className="col-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Select Role Type</label>
                            <div className="col-md-9">
                              <select
                                value={this.state.user_type}
                                name="user_type"
                                className="form-control"
                                onChange={this.handleChange}
                              >
                                {/* <option value="">ALL</option> */}
                                {getUserTypes().map((itm) => (
                                  <option
                                    value={itm.value}
                                    key={itm.value}
                                  >
                                    {itm.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Country</label>
                          <div className="col-sm-9">
                            <Select
                              name="countryData"
                              value={this.state.countryData}
                              onChange={this.handleCountryChange}
                              options={this.state.country_list}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClear}
                              placeholder="Select Options"
                              styles={{
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                  position: 'absolute',
                                  width: '100%',
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 text-right">
                        <Button
                          disabled={this.state.isSearching}
                          onClick={this.searchData}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="card">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      title={this.getListTitle()}
                      className="table-responsive"
                      data={this.state.userList}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AllUserList
